var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools-counter"},[_c('BaseIcon',{attrs:{"type":'listing'}}),_c('span',[_vm._v(_vm._s(_vm.count)+" "+_vm._s(_vm.$t('message.common.tools.results')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }